import { useState, useEffect } from 'react';
import { getFirestore, doc, getDoc } from 'firebase/firestore';

const DEFAULT_MAP_SETTINGS = {
  enabled: true,
  provider: 'openstreet',
  apiKey: '',
  mapboxToken: '',
  mapboxStyle: 'mapbox://styles/mapbox/streets-v12',
  homeMapHeroEnabled: false
};

let sessionMapSettings = null;
let mapSettingsInflight = null;

function fetchMapSettingsOnce() {
  if (sessionMapSettings) return Promise.resolve(sessionMapSettings);
  if (mapSettingsInflight) return mapSettingsInflight;

  mapSettingsInflight = (async () => {
    try {
      const db = getFirestore();
      const configDoc = await getDoc(doc(db, 'config', 'mapSettings'));
      sessionMapSettings = configDoc.exists()
        ? { ...DEFAULT_MAP_SETTINGS, ...configDoc.data() }
        : { ...DEFAULT_MAP_SETTINGS };
    } catch (error) {
      console.error('Erro ao carregar configurações do mapa:', error);
      sessionMapSettings = { ...DEFAULT_MAP_SETTINGS };
    } finally {
      mapSettingsInflight = null;
    }
    return sessionMapSettings;
  })();

  return mapSettingsInflight;
}

export const useMapSettings = () => {
  const [mapSettings, setMapSettings] = useState(
    () => sessionMapSettings || { ...DEFAULT_MAP_SETTINGS }
  );
  const [loading, setLoading] = useState(() => !sessionMapSettings);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const next = await fetchMapSettingsOnce();
      if (!cancelled) {
        setMapSettings(next);
        setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return { mapSettings, loading };
};
